export default __webpack_public_path__ + "media/images/gradient3-323094308824e8ab32a0bf98fa689591.png";